import store from '@/store/Index.js';

const DISABLED_STATUSES = ['suspended', 'withdrawn', 'dismissed'];

export default async (to, from, next) => {
    // Skip check if already on the restricted page
    if (to.path === '/restricted') {
        return next();
    }

    const authUser = store.state.Auth.user;

    // Skip if no user (not authenticated)
    if (!authUser) {
        return next();
    }

    // Check if user has any disabling statuses
    // Statuses should be loaded via the API login response
    const hasDisabledStatus = authUser?.statuses?.some(status => DISABLED_STATUSES.includes(status.name));

    if (hasDisabledStatus) {
        // Redirect to restricted page
        return next({ path: '/restricted' });
    }

    return next();
};
